// src/components/Layout/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FileText, Github, Linkedin } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();
  const brandColor = '#1A9E96';        
  const brandColorHover = '#157F79';  

  return (
    <footer className="app-footer bg-dark text-white py-4 mt-auto">
      <Container>
        <Row className="align-items-center">
          <Col md={4} className="text-center text-md-start mb-3 mb-md-0">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-2">
              <FileText size={24} style={{ color: brandColor }} />
              <span className="fw-bold fs-5" style={{ color: brandColor }}>
                Fast Global Resume
              </span>
            </div>
          </Col>

          <Col md={4} className="text-center mb-3 mb-md-0">
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/templates" className="footer-link">Templates</Link>
              <Link to="/pricing" className="footer-link">Pricing</Link>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/privacy" className="footer-link">Privacy</Link>
              <Link to="/terms" className="footer-link">Terms</Link>
            </div>
          </Col>

          <Col md={4} className="text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-3">
              <a
                href="https://github.com/tarannamfatima-dev"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social"
                aria-label="GitHub"
                style={{ color: brandColor }}
                onMouseEnter={(e) => e.currentTarget.style.color = brandColorHover}
                onMouseLeave={(e) => e.currentTarget.style.color = brandColor}
              >
                <Github size={20} />
              </a>
              <a
                href="https://www.linkedin.com/in/tarannamfatima"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social"
                aria-label="LinkedIn"
                style={{ color: brandColor }}
                onMouseEnter={(e) => e.currentTarget.style.color = brandColorHover}
                onMouseLeave={(e) => e.currentTarget.style.color = brandColor}
              >
                <Linkedin size={20} />
              </a>
            </div>
          </Col>
        </Row>

        <hr className="border-secondary my-3" />

        <div className="text-center text-white-50 small">
          &copy; {year} Fast Global Resume. All rights reserved.
        </div>
      </Container>
    </footer>
  );
};

export default Footer;